function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnhanceFormulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.69,141.46a9,9,0,0,0-2.65-6.37l-3.81-3.81a9,9,0,0,0-12.74,0L176.76,155l-70.95,70a9,9,0,0,0,0,12.73l3.82,3.82h0a8.94,8.94,0,0,0,6.36,2.64h0a9,9,0,0,0,6.35-2.63l79.9-79.12a3.94,3.94,0,0,0,.73-.56,4.45,4.45,0,0,0,.55-.7l13.51-13.38A9,9,0,0,0,219.69,141.46Zm-103,94.46a1,1,0,0,1-1.42,0l-3.82-3.82a1,1,0,0,1,0-1.4l71-70,6.86-6.86,5.15,5.15Zm94.69-93.76-11.3,11.2-5.19-5.18,11.24-11.24a1,1,0,0,1,1.42,0l3.82,3.81a1,1,0,0,1,.3.71A1,1,0,0,1,211.4,142.16Z",
    style: {
      fill: "#9c9fa3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.38,122.94a4,4,0,0,1-2.83-6.83l12.92-12.92a4,4,0,0,1,5.66,5.65l-12.92,12.93A4,4,0,0,1,229.38,122.94Z",
    style: {
      fill: "#f8b417"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.6,
    y: 85.64,
    width: 8,
    height: 26.27,
    rx: 4,
    style: {
      fill: "#f8b417"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.88,123.05a4,4,0,0,1-2.83-1.17L160.13,109a4,4,0,1,1,5.65-5.66l12.92,12.91a4,4,0,0,1-2.82,6.83Z",
    style: {
      fill: "#f8b417"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.58,149.83a4,4,0,1,1,0-8h18.27a4,4,0,0,1,0,8Z",
    style: {
      fill: "#f8b417"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.77,
    y: 179.58,
    width: 8,
    height: 26.27,
    rx: 4,
    style: {
      fill: "#f8b417"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.52,149.67a4,4,0,0,1,0-8h18.27a4,4,0,0,1,0,8Z",
    style: {
      fill: "#f8b417"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.7,162.08a13.57,13.57,0,0,0-13.56,13.55V275.87a14.49,14.49,0,1,1-29,0V175.63a13.57,13.57,0,0,0-13.56-13.55,4,4,0,0,0,0,8,5.56,5.56,0,0,1,5.56,5.55V275.87a22.49,22.49,0,1,0,45,0V175.63a5.56,5.56,0,0,1,5.56-5.55,4,4,0,0,0,0-8Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,237.46H242a4,4,0,0,1,0-8h15.37a4,4,0,0,1,0,8Z",
    style: {
      fill: "#ef5051"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceFormulation);
export default __webpack_public_path__ + "static/media/enhance-formulation.76b93a5fc839fb80b8624ecfca0f2850.svg";
export { ForwardRef as ReactComponent };